"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useLeaveAvatarPopup_hook_exports = {};
__export(useLeaveAvatarPopup_hook_exports, {
  default: () => useLeaveAvatarPopup_hook_default
});
module.exports = __toCommonJS(useLeaveAvatarPopup_hook_exports);
var import_react = require("react");
const useLeaveAvatarPopup = (isOpen, avatarCardRef, setIsOpen) => {
  const handleKeyDown = (event) => {
    if (event.key !== "Tab" || !avatarCardRef.current) return;
    const focusableElements = Array.from(
      avatarCardRef.current.querySelectorAll("button, a")
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    if (event.shiftKey && document.activeElement === firstElement) {
      setIsOpen(false);
      return;
    }
    if (!event.shiftKey && document.activeElement === lastElement) {
      setIsOpen(false);
    }
  };
  (0, import_react.useEffect)(() => {
    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    } else {
      document.removeEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);
};
var useLeaveAvatarPopup_hook_default = useLeaveAvatarPopup;
//# sourceMappingURL=useLeaveAvatarPopup.hook.js.map